export const cleanupStep3 = (data) => {
  const cleanedData = { ...data };
  
  // Если специализация отключена, очищаем все связанные данные
  if (!cleanedData.preferences.specialization) {
    cleanedData.preferences.inclusiveGroup = false;
    cleanedData.preferences.diseaseType = '';
    cleanedData.preferences.diseaseDocument = {
      type: '',
      number: '',
      issuedTo: '',
      issueDate: '',
      files: []
    };
  }
  
  // Если не выбран тип заболевания, очищаем документы
  if (!cleanedData.preferences.diseaseType) {
    cleanedData.preferences.diseaseDocument = {
      type: '',
      number: '',
      issuedTo: '',
      issueDate: '',
      files: []
    };
  }
  
  return cleanedData;
};